import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0223 from "../lesson-23/lesson";
import lesson0224 from "../lesson-24/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "a6be12a3-8d73-4e50-aef3-bdecca7e0833",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0223),
    lesson: lesson0223,
  },
  {
    id: "8b23f749-09c1-4e18-b56d-cbd7354bb18f",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0224),
    lesson: lesson0224,
  },
];

export default lessonLinks;
